import React, { useEffect, useState, useRef } from 'react';
import './styles/Pages.css';
import html5 from '../assets/skills/html5_fn.png';
import css3 from '../assets/skills/css_fn.png'
import js from '../assets/skills/js_fn.png'
import php from '../assets/skills/php_fn.png'
import python from '../assets/skills/py_fn.png'
import java from '../assets/skills/java_fn.png'
import psd from '../assets/skills/psd_fn.png'
import ai from '../assets/skills/ai_fn.png'
import ux from '../assets/skills/ux-ui-fn.png'
import sqlserver from '../assets/skills/sql_server.png'

import axios from 'axios'; 

const About = () => {
   const skillsRef = useRef(null);
   const [isVisible, setIsVisible] = useState(false);

   //console.log("se añade la animacion 11");
   const [aboutme, setAboutme] = useState('');
   const [isLoadingAboutme, setIsLoadingAboutme] = useState(true); 
   const [skills, setSkills] = useState([]);

   const fetchSkills = async () => {
      const response = await fetch('https://www.noecer.com/api/portfolio/skills/getdata');
      const data = await response.json();
      setSkills(data);
   };

   useEffect(() => {
      fetchSkills();

      axios.get('https://www.noecer.com/api/portfolio/aboutme/getdata')
      .then((response) => {
         //Sólo obtengo el texto
         setAboutme(response.data.description);
         setIsLoadingAboutme(false);
      })
      .catch((error)=>{
         setIsLoadingAboutme(false);
         console.error("Hubo un error consultando el API de JAVA",error);
     });

     if (isLoadingAboutme === 0) return

     const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true); // activa animación
        } else {
          setIsVisible(false); // reinicia animación
        }
      },
      { threshold: 0.3 } // se activa cuando el 30% del elemento es visible
    );

    if (skillsRef.current) {
      observer.observe(skillsRef.current);
    }

    return () => {
      if (skillsRef.current) {
        observer.unobserve(skillsRef.current);
      }
    };
   }, [skills]);

   // Función para dividir las skills en dos grupos
   const divideSkills = (skills) => {
      const half = Math.ceil(skills.length / 2);
      const firstGroup = skills.slice(0, half);
      const secondGroup = skills.slice(half);
      return [firstGroup, secondGroup];
   };

   const [group1, group2] = divideSkills(skills);

   return (
      <div className='about_skill'>
         <section className='about'>
            <h1>Sobre mi</h1>
            {/* <p>Soy Bachiller en Ingeniería de Sistemas e Informática con más de 3 años de experiencia
               en el desarrollo y mantenimiento de aplicaciones robustas y escalables.
               Poseo excelentes habilidades y conocimientos en bases de datos, así como en
               tecnologías web y de escritorio. Tengo la capacidad de expresarme de manera clara,
               fluida y persuasiva. Me destaco por mi responsabilidad, liderazgo, y mi habilidad
               para trabajar bajo presión y en equipo. </p> */}
            <p>{aboutme || 'Cargando...'}</p>
         </section>
         <section className="skills" id="skills" ref={skillsRef}>
            <div className='text_skills'>
               <h1 className='title_skill'>Mis Habilidades</h1>
               <p>Los proyectos que he iniciado desde cero me han permitido ganar experiencia en el uso de las siguientes tecnologías...</p>
            </div>

            <div className="skills-group">
               <div className="skills-1">
                  {group1.map((skill) => (
                     <div key={skill.alias} className="skill-data">
                     <img src={`https://www.noecer.com/recursos_portfolio/skills/${skill.alias}_fn.png`} alt="Logo" className="skill-logo" />
                     <div className="skill-info">
                        <div className="skill-titles">
                           <h1 className="skill-name">{skill.name}</h1>
                           <span className="skill-number">{skill.percentage}%</span>
                        </div>
                        <div className="skill-bar">
                           <span
                              className="skill-percentage skill-fill"
                              style={{
                                 transform: `scaleX(${skill.percentage / 100})`,
                                 backgroundColor: `#80DBBF`,
                                 transformOrigin: 'left',
                                 animation: isVisible
                                   ? `fillSkill 2s ease-in-out forwards`
                                   : 'none', // para evitar que se quede llena al salir
                               }}
                           ></span>
                        </div>
                     </div>
                     </div>
                  ))}
               </div>
            {/* </div>
            <div className="skills-group"> */}
               <div className="skills-2">
                  {group2.map((skill) => (
                     <div key={skill.alias} className="skill-data">
                     <img src={`https://www.noecer.com/recursos_portfolio/skills/${skill.alias}_fn.png`} alt="Logo" className="skill-logo" />
                     <div className="skill-info">
                        <div className="skill-titles">
                           <h1 className="skill-name">{skill.name}</h1>
                           <span className="skill-number">{skill.percentage}%</span>
                        </div>
                        <div className="skill-bar">
                           <span
                              className="skill-percentage skill-fill"
                              style={{
                                 transform: `scaleX(${skill.percentage / 100})`,
                                 backgroundColor: `#80DBBF`,
                                 transformOrigin: 'left',
                                 animation: isVisible
                                   ? `fillSkill 2s ease-in-out forwards`
                                   : 'none', // para evitar que se quede llena al salir
                               }}
                           ></span>
                        </div>
                     </div>
                     </div>
                  ))}
               </div>
            </div>
         </section >
      </div >

   );
};

export default About;